import { useGetAgencies } from "@entities/agency";
import { Avatar, Col, Flex, Input, Row, Spin } from "antd";
import { useState } from "react";

import styles from "../styles.module.scss";
import { Button } from "@shared/ui/Button";

export function AgencySelectForm({
  handleAdd,
  onClose,
  isLoading,
}: {
  handleAdd: (agencyId: string) => void;
  onClose: () => void;
  isLoading: boolean;
}) {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { agencies, isFetching } = useGetAgencies(searchQuery);
  const [selectedAgency, setSelectedAgency] = useState<string | null>(null);

  return (
    <Flex vertical gap={16}>
      {" "}
      <Input.Search
        placeholder="Search Agency"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginBottom: 16 }}
      />
      <div style={{ maxHeight: 300, overflowY: "auto" }}>
        {isFetching ? (
          <Row justify="center" align="middle">
            <Spin />
          </Row>
        ) : (
          agencies?.data?.map((agency) => (
            <Row
              key={agency._id}
              style={{
                alignItems: "center",
                padding: 8,
                background:
                  selectedAgency === agency._id ? "#E6F4FF" : undefined,
                cursor: "pointer",
                borderRadius: 6,
                marginBottom: 4,
              }}
              onClick={() => setSelectedAgency(agency?._id)}
            >
              <Col span={4}>
                <Avatar src={agency.profilePicUrl} size={40} />
              </Col>
              <Col span={16}>
                <div className={styles.permItemTitle}>{agency.name}</div>
                <div className={styles.permItemDesc}>{agency.companyName}</div>
              </Col>
            </Row>
          ))
        )}
      </div>
      <Flex justify="end" gap={8}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          type="primary"
          loading={isLoading}
          disabled={!selectedAgency}
          onClick={() => {
            if (selectedAgency) {
              handleAdd(selectedAgency);
              setSelectedAgency(null);
            }
          }}
        >
          Link
        </Button>
      </Flex>
    </Flex>
  );
}
